// Generated from insurance-contract.json at 2025-04-21T16:23:15.527Z

import { PolicyType } from "@quantizr-engineering/common/types/insurance-contract";
import { enumToOptions } from "../../utils/enumToOptions";
import { DocMap, FieldsMap } from "./";
import hourglass from "../../assets/hourglass-01.svg";

const creedSummaryFieldsMap: FieldsMap = {
  partiesAndDate: {
    name: "partiesAndDate",
    label: "Parties and Date",
    required: false,
    type: "array",
    subfields: [
      // {
      //   name: "artistName",
      //   label: "Artist Name",
      //   required: false,
      //   type: "text",
      // },
      {
        name: "insuranceCompany",
        label: "Insurance Company",
        required: false,
        type: "text",
      },
      {
        name: "coverageStartDate",
        label: "Coverage Start Date",
        required: false,
        type: "date",
      },
      {
        name: "coverageEndDate",
        label: "Coverage End Date",
        required: false,
        type: "date",
      },
    ],
  },
  keyPoints: {
    name: "keyPoints",
    label: "Key Points",
    required: false,
    type: "array",
    subfields: [
      {
        name: "policyType",
        label: "Policy Type",
        required: false,
        type: "select",
        options: enumToOptions(PolicyType),
      },
      {
        name: "coverageTypes",
        label: "Coverage Types",
        required: false,
        type: "textArray",
      },
    ],
  },
};

const creedDataFieldsMap: FieldsMap = {
  propertySummary: {
    name: "propertySummary",
    label: "Property Summary",
    required: false,
    type: "array",
    subfields: [
      {
        name: "address",
        label: "Address",
        required: false,
        type: "text",
      },
      {
        name: "type",
        label: "Type",
        required: false,
        type: "text",
      },
      {
        name: "characteristics",
        label: "Characteristics",
        required: false,
        type: "array",
        subfields: [
          {
            name: "characteristic",
            label: "Characteristic",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "itemsCovered",
        label: "Items Covered",
        required: false,
        type: "array",
        subfields: [
          {
            name: "itemsCovered",
            label: "Items Covered",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  premium: {
    name: "premium",
    label: "Premium",
    required: false,
    type: "array",
    subfields: [
      {
        name: "total",
        label: "Total",
        required: false,
        type: "number",
      },
      {
        name: "base",
        label: "Base",
        required: false,
        type: "number",
      },
      {
        name: "frequency",
        label: "Frequency",
        required: false,
        type: "text",
      },
      {
        name: "fees",
        label: "Fees",
        required: false,
        type: "array",
        subfields: [
          {
            name: "type",
            label: "Type",
            required: false,
            type: "text",
          },
          {
            name: "amount",
            label: "Amount",
            required: false,
            type: "number",
          },
        ],
      },
    ],
  },

  coverageExtensionNotes: {
    name: "coverageExtensionNotes",
    label: "Coverage Extension Notes",
    required: false,
    type: "text",
  },

  automaticRenewal: {
    name: "automaticRenewal",
    label: "Automatic Renewal",
    required: false,
    type: "array",
    subfields: [
      {
        name: "automaticRenewal",
        label: "Automatic Renewal",
        required: false,
        type: "boolean",
      },
      {
        name: "notificationPeriod",
        label: "Notification Period",
        required: false,
        type: "text",
      },
      {
        name: "conditions",
        label: "Conditions",
        required: false,
        type: "text",
      },
    ],
  },

  renewalDate: {
    name: "renewalDate",
    label: "Renewal Date",
    required: false,
    type: "date",
  },

  exclusions: {
    name: "exclusions",
    label: "Exclusions",
    required: false,
    type: "text",
  },

  primaryDeductible: {
    name: "primaryDeductible",
    label: "Primary Deductible",
    required: false,
    type: "array",
    subfields: [
      {
        name: "amount",
        label: "Amount",
        required: false,
        type: "number",
      },
      {
        name: "type",
        label: "Type",
        required: false,
        type: "text",
      },
      {
        name: "applicability",
        label: "Applicability",
        required: false,
        type: "text",
      },
    ],
  },

  specifiedDeductibles: {
    name: "specifiedDeductibles",
    label: "Specified Deductibles",
    required: false,
    type: "array",
    subfields: [
      {
        name: "amount",
        label: "Amount",
        required: false,
        type: "number",
      },
      {
        name: "appliesTo",
        label: "Applies To",
        required: false,
        type: "text",
      },
      {
        name: "conditions",
        label: "Conditions",
        required: false,
        type: "text",
      },
    ],
  },

  primaryLimit: {
    name: "primaryLimit",
    label: "Primary Limit",
    required: false,
    type: "array",
    subfields: [
      {
        name: "occurrence",
        label: "Occurrence",
        required: false,
        type: "number",
      },
      {
        name: "aggregate",
        label: "Aggregate",
        required: false,
        type: "number",
      },
      {
        name: "appliesTo",
        label: "Applies To",
        required: false,
        type: "text",
      },
    ],
  },

  specifiedLimits: {
    name: "specifiedLimits",
    label: "Specified Limits",
    required: false,
    type: "array",
    subfields: [
      {
        name: "amount",
        label: "Amount",
        required: false,
        type: "number",
      },
      {
        name: "appliesTo",
        label: "Applies To",
        required: false,
        type: "text",
      },
      {
        name: "relationship",
        label: "Relationship",
        required: false,
        type: "text",
      },
    ],
  },

  nameInsured: {
    name: "nameInsured",
    label: "Name Insured",
    required: false,
    type: "array",
    subfields: [
      {
        name: "nameInsured",
        label: "Name Insured",
        type: "text",
        required: false,
      },
    ],
  },

  additionalInsured: {
    name: "additionalInsured",
    label: "Additional Insured",
    required: false,
    type: "array",
    subfields: [
      {
        name: "name",
        label: "Name",
        required: false,
        type: "text",
      },
      {
        name: "relationship",
        label: "Relationship",
        required: false,
        type: "text",
      },
      {
        name: "limitations",
        label: "Limitations",
        required: false,
        type: "text",
      },
    ],
  },

  requiredActions: {
    name: "requiredActions",
    label: "Required Actions",
    required: false,
    type: "array",
    subfields: [
      {
        name: "requiredAction",
        label: "Required Action",
        type: "text",
        required: false,
      },
    ],
  },

  potentialCredits: {
    name: "potentialCredits",
    label: "Potential Credits",
    required: false,
    type: "array",
    subfields: [
      {
        name: "credit",
        label: "Credit",
        required: false,
        type: "text",
      },
      {
        name: "action",
        label: "Action",
        required: false,
        type: "text",
      },
    ],
  },

  claimsProcedure: {
    name: "claimsProcedure",
    label: "Claims Procedure",
    required: false,
    type: "array",
    subfields: [
      {
        name: "notification",
        label: "Notification",
        required: false,
        type: "text",
      },
      {
        name: "documentation",
        label: "Documentation",
        required: false,
        type: "array",
        subfields: [
          {
            name: "documentation",
            label: "Documentation",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "examination",
        label: "Examination",
        required: false,
        type: "text",
      },
      {
        name: "requiredActions",
        label: "Required Actions",
        required: false,
        type: "text",
      },
    ],
  },

  cancellationTerms: {
    name: "cancellationTerms",
    label: "Cancellation Terms",
    required: false,
    type: "array",
    subfields: [
      {
        name: "insuredNotice",
        label: "Insured Notice",
        required: false,
        type: "text",
      },
      {
        name: "insurerNotice",
        label: "Insurer Notice",
        required: false,
        type: "array",
        subfields: [
          {
            name: "nonpayment",
            label: "Nonpayment",
            required: false,
            type: "text",
          },
          {
            name: "otherReasons",
            label: "Other Reasons",
            required: false,
            type: "text",
          },
        ],
      },
      {
        name: "refund",
        label: "Refund",
        required: false,
        type: "array",
        subfields: [
          {
            name: "insurerCancels",
            label: "Insurer Cancels",
            required: false,
            type: "text",
          },
          {
            name: "insuredCancels",
            label: "Insured Cancels",
            required: false,
            type: "text",
          },
        ],
      },
      {
        name: "deliveryRequirements",
        label: "Delivery Requirements",
        required: false,
        type: "array",
        subfields: [
          {
            name: "deliveryRequirement",
            label: "Delivery Requirement",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  waitingPeriods: {
    name: "waitingPeriods",
    label: "Waiting Periods",
    required: false,
    type: "array",
    subfields: [
      {
        name: "period",
        label: "Period",
        required: false,
        type: "text",
      },
      {
        name: "appliesTo",
        label: "Applies To",
        required: false,
        type: "text",
      },
      {
        name: "exceptions",
        label: "Exceptions",
        required: false,
        type: "array",
        subfields: [
          {
            name: "exception",
            label: "Exception",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  endorsementsRiders: {
    name: "endorsementsRiders",
    label: "Endorsements Riders",
    required: false,
    type: "array",
    subfields: [
      {
        name: "form",
        label: "Form",
        required: false,
        type: "text",
      },
      {
        name: "title",
        label: "Title",
        required: false,
        type: "text",
      },
      {
        name: "description",
        label: "Description",
        required: false,
        type: "array",
        subfields: [
          {
            name: "description",
            label: "Description",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "limits",
        label: "Limits",
        required: false,
        type: "array",
        subfields: [
          {
            name: "limit",
            label: "Limit",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  subrogationRights: {
    name: "subrogationRights",
    label: "Subrogation Rights",
    required: false,
    type: "array",
    subfields: [
      {
        name: "scope",
        label: "Scope",
        required: false,
        type: "text",
      },
      {
        name: "waiverCircumstances",
        label: "Waiver Circumstances",
        required: false,
        type: "array",
        subfields: [
          {
            name: "waiverCircumstance",
            label: "Waiver Circumstance",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "insuredObligations",
        label: "Insured Obligations",
        required: false,
        type: "array",
        subfields: [
          {
            name: "insuredObligation",
            label: "Insured Obligation",
            type: "text",
            required: false,
          },
        ],
      },
    ],
  },

  territory: {
    name: "territory",
    label: "Territory",
    required: false,
    type: "array",
    subfields: [
      {
        name: "coverageTerritory",
        label: "Coverage Territory",
        required: false,
        type: "text",
      },
      {
        name: "limitations",
        label: "Limitations",
        required: false,
        type: "array",
        subfields: [
          {
            name: "limitation",
            label: "Limitation",
            type: "text",
            required: false,
          },
        ],
      },
      {
        name: "governingLaw",
        label: "Governing Law",
        required: false,
        type: "text",
      },
    ],
  },
};

export const CreedInsuranceContractMap: DocMap = {
  summaryFields: creedSummaryFieldsMap,
  dataFields: creedDataFieldsMap,
  entityHrefTitle: () => "Coming soon...",
  entityHrefIcon: () => hourglass,
  entityHrefSubtitle: () => "",
  entityHref: null,
};
